import http from "./httpService";

export function searchBsps(q) {
  return http.get("/search/?q=" + q);
}